export const MARKING_EDITOR_WEB_COMPONENT_ELEMENT = 'marking-editor-web-component';
export const TEXTAREA_INPUTWRAPDIV_ID = 'textarea-inputwrapdiv';
export const TEXTAREA_TEXTINPUTDIV_ID = 'textarea-textinputdiv';